import React from "react";
import { fr } from "date-fns/locale";
import { Calendar } from "./ui/calendar";

const eur = (n) => `${Number(n).toLocaleString("fr-FR", { maximumFractionDigits: 0 })} €`;

export function NomadeForm({ range, setRange, disabled }) {
  return (
    <div className="border border-border rounded-2xl p-6 bg-card" data-testid="nomade-form">
      <p className="overline text-[#2B8B8E] mb-3">Pass Nomade — Choisissez votre période</p>
      <p className="text-sm text-muted-foreground mb-4">
        Sélectionnez librement votre date de début, puis votre date de fin (durée maximum 2 mois).
      </p>
      <div className="inline-block border border-border rounded-xl p-3 bg-background">
        <Calendar
          mode="range"
          locale={fr}
          weekStartsOn={1}
          numberOfMonths={2}
          selected={range}
          onSelect={(r) => r && setRange(r)}
          disabled={disabled}
          data-testid="nomade-calendar"
        />
      </div>
      {range.from && range.to && (
        <div className="mt-4 p-3 rounded-xl bg-[#2B8B8E]/5 text-sm">
          Du <strong>{range.from.toLocaleDateString("fr-FR")}</strong> au <strong>{range.to.toLocaleDateString("fr-FR")}</strong>
          {" · "}
          <span className="text-[#2B8B8E] font-semibold">
            {Math.round((range.to - range.from) / 86400000) + 1} jour(s)
          </span>
        </div>
      )}
      <p className="mt-3 text-[10px] text-muted-foreground">Les dates au-delà de 2 mois après votre date de début seront automatiquement bloquées.</p>
    </div>
  );
}

export function ResidentForm({ months, setMonths, start, setStart, endDate, pricing, today }) {
  return (
    <div className="space-y-6">
      <div className="border border-border rounded-2xl p-6 bg-card" data-testid="resident-step-1">
        <p className="overline text-[#2B8B8E] mb-3">Étape 1 — Durée d'abonnement</p>
        <div className="grid grid-cols-4 md:grid-cols-6 gap-2">
          {Array.from({ length: 12 }).map((_, i) => {
            const m = i + 1;
            return (
              <button key={m} onClick={() => setMonths(m)} data-testid={`resident-months-${m}`}
                className={`p-3 rounded-xl border-2 text-sm font-semibold transition ${months === m ? "border-[#2B8B8E] bg-[#2B8B8E]/10 text-[#0D2C4D]" : "border-border hover:border-[#2B8B8E]/40"}`}>
                {m} mois
                {m === 12 && <span className="block text-[9px] font-bold text-[#2B8B8E] mt-1">-1 MOIS OFFERT</span>}
              </button>
            );
          })}
        </div>
      </div>

      <div className="border border-border rounded-2xl p-6 bg-card" data-testid="resident-step-2">
        <p className="overline text-[#2B8B8E] mb-3">Étape 2 — Date de début</p>
        <div className="inline-block border border-border rounded-xl p-3 bg-background">
          <Calendar
            mode="single"
            locale={fr}
            weekStartsOn={1}
            selected={start}
            onSelect={(d) => d && setStart(d)}
            disabled={(d) => d < today}
            data-testid="resident-calendar"
          />
        </div>
        <div className="mt-4 p-3 rounded-xl bg-[#2B8B8E]/5 text-sm">
          Abonnement du <strong>{start.toLocaleDateString("fr-FR")}</strong> au <strong>{endDate.toLocaleDateString("fr-FR")}</strong>
        </div>
      </div>

      <div className="border-2 border-[#2B8B8E] rounded-2xl p-6 bg-[#2B8B8E]/5" data-testid="resident-pricing">
        <p className="overline text-[#2B8B8E] mb-3">Récapitulatif tarifaire</p>
        <div className="space-y-1 text-sm">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Prix normal ({months} × 220 €)</span>
            <span className={pricing.freeMonth ? "line-through text-muted-foreground" : "font-semibold"}>{eur(pricing.base)}</span>
          </div>
          {pricing.freeMonth && (
            <>
              <div className="flex justify-between text-[#2B8B8E]">
                <span>🎁 Offre 12 mois — 1 mois offert</span>
                <span>−{eur(pricing.saving)}</span>
              </div>
              <div className="flex justify-between border-t border-[#2B8B8E]/20 pt-2 mt-2">
                <span className="font-semibold text-[#0D2C4D]">Prix final</span>
                <span className="text-2xl font-bold text-[#2B8B8E]">{eur(pricing.final)}</span>
              </div>
            </>
          )}
          {!pricing.freeMonth && (
            <div className="flex justify-between border-t border-border pt-2 mt-2">
              <span className="font-semibold">Total à payer</span>
              <span className="text-2xl font-bold text-[#2B8B8E]">{eur(pricing.final)}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
